<template>
  <modal name="modal-add-note" height="auto" :width="700"
         :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>NEW NOTE</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <template v-if="postData">
      <form method="post" action="" ref="form" @submit.prevent="doCreate">
        <div class="form-group">
          <label for="title">Title <span class="text-danger">*</span></label>
          <input type="text" name="title" id="title" ref="inputTitle"
                 :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                 v-validate.disable="{ required: true }"
                 v-model="postData.title">
          <div class="invalid-feedback">{{ errors.first('title') }}</div>
        </div>
        <div class="form-group" :class="{'d-none': hideClientSelector}">
          <label for="client_id">Client</label>
          <select name="client_id" id="client_id"
                  :class="{'form-control': true, 'is-invalid': errors.has('client_id')}"
                  v-model="postData.client_id">
            <option value="">- Select -</option>
            <option v-for="client in CLIENTS" :key="client.id" :value="client.id">
              {{ client.name }}
            </option>
          </select>
          <div class="invalid-feedback">{{ errors.first('client_id') }}</div>
        </div>
        <div class="form-group">
          <label>Content <span class="text-danger">*</span></label>
          <editor :api-key="tinyApiKey" :init="tinyOpts" v-model="postData.content"></editor>
          <div class="invalid-feedback">{{ errors.first('content') }}</div>
        </div>
        <div class="pt-2 btns btns-2">
          <beat-loader v-if="state == 'saving'"></beat-loader>
          <template v-else>
            <button type="submit" class="btn btn-outline-black mr-2">Submit</button>
            <button type="button" class="btn btn-outline-gray" @click="closeModal">Cancel</button>
          </template>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Editor from '@tinymce/tinymce-vue'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import ServiceNote from '@/services/note'

  export default {
    components: {
      BeatLoader,
      Editor,
    },
    data () {
      return {
        state: '',
        postData: false,
        hideClientSelector: false
      }
    },
    props: ['value', 'clientId'],
    computed: {
      ...mapGetters(['CLIENTS']),
      ...mapState({
        tinyApiKey: state => state.option.tinyApiKey,
        tinyOpts: state => state.option.tinyOpts
      }),
    },
    watch: {
      clientId: 'init',
      value ( newVal ) {
        let self = this;
        if ( newVal ) {
          self.$modal.show('modal-add-note', {});
          setTimeout(() => {
            self.$refs.inputTitle.focus();
          }, 200);
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      init () {
        let self = this;
        self.hideClientSelector = typeof self.clientId != 'undefined' && self.clientId;
        self.resetForm();
        if(self.hideClientSelector){
          self.postData.client_id = self.clientId;
        }
      },
      resetForm () {
        let self = this;
        self.postData = {
          title: '',
          client_id: '',
          content: ''
        };
      },
      closeModal () {
        this.$modal.hide('modal-add-note');
      },
      doCreate ( ) {
        let self = this;

        if (self.state == 'saving') {
          return;
        }

        self.$validator.validateAll()
          .then(ok => {
            if ( ok ) {
              self.state = 'saving';
              ServiceNote.create(self.postData, note => {
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: 'Note <strong>' + note.title + '</strong> created'
                });
                self.resetForm();
                self.$emit('note-created', note);
                self.closeModal();
              }, () => {
                self.state = '';
              });
            }
          });
      }
    }
  }
</script>
